import { mapState } from 'vuex';

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapState(["loginData"]),
    jurisdictionMenu () {
      let newArr = [],group = this.loginData.group || {};
      let rules_url = [];
      try {
        rules_url = group.rules_url || [];
      } catch (error) {
        return []
      }
      let rules_name = group.rules_name || [];
      rules_url.forEach((e, idx) => {
        newArr.push({
          name: e,
          title: rules_name[idx] || ''
        })
      });
      return newArr
    },
  },
  methods:{
    isJurisdiction(key) {
      // return true;
      return !!this.jurisdictionMenu.filter(e => e.name == key).length;
    }
  },
  methods: {
  }
};